jQuery(document).ready(function ($) {
    // detail-products-viewed
    if (window.innerWidth < 992) {
        const _sliderViewed = $('.detail-products-viewed');
        _sliderViewed.slick({
            variableWidth: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScrol1: 1,
            // dots: false,
            // arrows: true,
            swipeToSlide: true,
            touchMove: true,
        });
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('v2-product-single__infomations--tabs-content__item--more')) {
            const parent = e.target.closest('.v2-product-single__infomations--tabs-content__item');
            const content = parent.querySelector('.infomations__descriptions');

            if (content) {
                if (content.classList.contains('is-active')) {
                    content.classList.remove('is-active');
                    e.target.textContent = 'Xem thêm';
                } else {
                    content.classList.add('is-active');
                    e.target.textContent = 'Thu gọn';
                }
            }
        }

        if (e.target.classList.contains('v2-product-single__infomations--tabs-panel__title')) {
            const parent = e.target.closest('.v2-product-single__infomations--tabs-panel');
            if (!parent) return;

            const activeTab = parent.querySelector('.active');
            if (activeTab) {
                activeTab.classList.remove('active');
            }

            e.target.classList.add('active');

            const tabContent = e.target.getAttribute('data-id');
            if (!tabContent) return;

            const cnotentActive = document.querySelector('.v2-product-single__infomations--tabs-content__item.active');
            if (cnotentActive) {
                cnotentActive.classList.remove('active');
            }

            const content = document.querySelector(`.v2-product-single__infomations--tabs-content__item[id="${tabContent}"]`);
            if (content) {
                content.classList.add('active');
            }
        }
    })
})
